import axiosInstance from './axiosConfig';

export const getTransferRequestsApi = (params) =>
  axiosInstance.get('/transfer-requests', { params });

export const createTransferRequestApi = (payload) =>
  axiosInstance.post('/transfer-requests', payload);

export const cancelTransferRequestApi = (id) =>
  axiosInstance.post(`/transfer-requests/${id}/cancel`);

export const approveTransferRequestApi = (id, payload = {}) =>
  axiosInstance.post(`/transfer-requests/${id}/approve`, payload);

export const rejectTransferRequestApi = (id, payload = {}) =>
  axiosInstance.post(`/transfer-requests/${id}/reject`, payload);
